<template>
  <v-card outlined class="pa-6">
    <Typography variant="h-5" class="text-left mb-6">Processing Merge...</Typography>

    <div
      v-for="(step, i) in steps"
      :key="i"
      class="d-flex align-center"
      :class="i < steps.length - 1 ? 'mb-4' : ''"
      style="gap: 12px; min-height: 24px"
    >
      <v-progress-circular v-if="!completed[i]" indeterminate color="primary" size="24" width="2" />
      <v-icon v-else color="success" size="24">mdi-check-circle</v-icon>

      <Typography variant="body-1" class="text-left" :class="completed[i] ? 'grey--text' : ''">{{
        step.label
      }}</Typography>
    </div>
  </v-card>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";

export default {
  name: "MergeProgress",
  components: { Typography },
  props: {
    // Each step: { label: String, delay?: Number (ms) }
    // Last step should omit delay — it completes when the promise resolves.
    steps: {
      type: Array,
      default: () => [
        { label: "Closing card", delay: 300 },
        { label: "Transferring balance", delay: 700 },
        { label: "Updating data", delay: 1200 },
        { label: "Deleting account" },
      ],
    },
    // The API promise to wait on for the final step.
    promise: {
      type: Promise,
      default: null,
    },
  },
  emits: ["done", "error"],
  data() {
    return {
      completed: [],
      timers: [],
    };
  },
  created() {
    this.completed = this.steps.map(() => false);
    this.startTimers();
  },
  beforeUnmount() {
    this.timers.forEach((id) => clearTimeout(id));
  },
  methods: {
    startTimers() {
      const lastIndex = this.steps.length - 1;

      this.steps.forEach((step, i) => {
        if (i === lastIndex || !step.delay) return;
        const id = setTimeout(() => {
          this.$set(this.completed, i, true);
        }, step.delay);
        this.timers.push(id);
      });

      if (this.promise) {
        this.promise
          .then(() => {
            this.completeAll();
            this.$emit("done");
          })
          .catch((err) => {
            this.$emit("error", err);
          });
      }
    },
    completeAll() {
      this.timers.forEach((id) => clearTimeout(id));
      this.timers = [];
      this.completed = this.steps.map(() => true);
    },
  },
};
</script>
